<template>
    <div>
        <div class="flex" >
            <div><a-button class="top_btn" type="primary"   @click="exportList()"  >
                批量导出
            </a-button>
                <span style="margin-left: 8px">
        <template v-if="hasSelected">
          {{ `选中 ${selectedRowKeys.length} 项` }}
        </template></span></div>
            <div class="search-group flex">
                <a-input  v-model="search.company" class="search-input"  allowClear placeholder="请输入客户名称搜索" />
                <a-button type="primary" class="top_btn" @click="getList()">搜索</a-button>
<!--                <a-button type="danger" class="top_btn" @click="empty">清空</a-button>-->
            </div>
        </div>
        <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pagination" rowKey="id" @change="handleChange" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" >

        </a-table>

    </div>

</template>

<script>
    import API from "./api";
    import {changStatus, removeById,orderList} from "../../../utils/utils"
    const columns = [

        {
            title: "客户名称",
            key: "company",
            ellipsis: true,
            dataIndex: "company",
        },
        {
            title: "购买量",
            key: "translation_set_num",
            ellipsis: true,
            dataIndex: "translation_set_num",
        },
        {
            title: "使用量",
            key: "translation_use_num",
            ellipsis: true,
            dataIndex: "translation_use_num",
        },
        {
            title: "剩余量",
            key: "translation_surplus",
            ellipsis: true,
            dataIndex: "translation_surplus",
        },

    ];
    export default {
        name: 'index',
        data() {
            return {
                visibleForm: false,
                titleForm: "",
                loading: true,
                editId: null,
                data: [],
                selectedRowKeys: [], // Check here to configure the default column
                columns,
                company:"",
                search: {
                    company: "",
                },
                pagination: {
                    pageNo: 1,
                    pageSize: 20, // 默认每页显示数量
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                    onChange: this.getList.bind(this), //点击页码事件
                    total: 0, //总条数
                    current: 0,
                    size: "small",
                    showTotal: total => `共 ${total} 条`,
                    showQuickJumper: true
                },
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/DataStatistics/Translate"; //设置左侧导航2-2 active
        },
        computed: {
            hasSelected() {
                return this.selectedRowKeys.length > 0;
            },
        },
        methods: {
            handleChange(pagination, filters, sorter) {
                // this.filteredInfo = filters;
                // this.sortedInfo = sorter;
            },

            exportList(){
                API.service.EXPORT({company:this.company ,ids:this.selectedRowKeys }).then(res => {
                    window.open( `${this.$store.state.urlExper}${res.data.data.path.substr(1)}`  )
                    // this.selectedRowKeys=[]
                })
            },
            getList(page) {
                let seachData = JSON.parse(JSON.stringify(this.search))
                this.company=this.search.company
                API.service.GET_LIST({page: page || 1, ...seachData}).then(res => {
                    this.data = res.data.data.data
                    this.pagination.total=res.data.data.total
                    this.pagination.pageSize=res.data.data.per_page
                    this.pagination.current=res.data.data.current_page
                    this.selectedRowKeys=[]
                    this.loading = false
                })
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
        },
        mounted() {
            this.getList()
        }

    }
</script>
<style scoped>
    .inputs {
        display: inline-block;
        width: 70px
    }
    .search-group {
        float: right;
    }
    .search-group .ant-input {
        width: 200px;
        margin: 0 8px 0 0 ;
    }
    .button-group {
        float: left;
    }
    #list_order {
        width: 50px;
    }
    .search-group .search-input {
        width: 200px;height: 32px;
        margin: 0 8px 0 0 ;
    }
    .top .flex{ box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);padding:10px 16px;box-sizing: border-box;width: 60%;margin-bottom: 20px}
</style>
